<template>
  <div class="card" v-if="statistics">
    <div class="card--content">
      <p>
        {{$t('statistics.businesskit_sent')}}: <span class="value">{{businesskitSent}}</span>
      </p>
      <div class="card--number">
        <div class="card--number-value">
          {{businesskitOpened}}
        </div>
        <div class="card--number-key">
          {{$t('statistics.businesskit_opened')}}
        </div>
      </div>
      <hr>
      <div class="card--gauge">
        <gauge :percentage="businesskitSentOpenRatio"/>
      </div>
    </div>
  </div>
</template>
<script>
import { round } from "./StatisticsHelpers";
import Chartist from 'chartist'
import Gauge from '@/components/helpers/DataDisplay/Gauge'

export default {
  name: 'bk-sent',
  props: ['statistics'],
  components: { Gauge },
  computed: {
    businesskitSent(){
      return this.statistics.sent_business_kits_count
    },
    businesskitOpened(){
      return this.statistics.trackings_unique_bag_open_count
    },
    businesskitSentOpenRatio(){
      if(this.businesskitSent == 0){
        return 0
      }
      let result = this.businesskitOpened / this.businesskitSent
      return Math.round(result * 100)
    }
  }
}
</script>
<style lang="scss">
.panel.bk-sent{
  .card--content p{
    color: #989898;
    margin-bottom: -20px;
  }
  .card--gauge{
    text-align: center;
    margin-top: 20px;
    .gauge .percentage{
      color: #989898;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ProjectStatisticsBkSent.vue?79f29ff8